import type {RouteRecordRaw} from "vue-router";

export const routeName = 'ExternalDocumentLink';

export const route: RouteRecordRaw = {
    name: routeName,
    path: ':id/by-hash',
    component: () => import('@/pages/ExternalDocLink'),
    props: route => ({
        id: Number(route.params.id),
        hash: route.query.hash as string | undefined,
        token: route.query.token as string | undefined,
    }),
};